<span class="no-br after-{{after}}" [innerHTML]="text">
</span>

